import _ from 'lodash'
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

import ApiBrand from '@/models/api/brand'
import { BrandService } from '@/services/api/brand'
import { extractBrandFromUrl } from '@spa/router/hooks/lib/extract'

@Mixin
export default class BrandContextMixin extends Vue {
  private brandList: ApiBrand[] = []

  get initialBrandId(): string | null {
    return this.initialBrand !== null ? this.initialBrand.id : null
  }

  get initialBrandEnglishName(): string | null {
    return this.initialBrand !== null ? this.initialBrand.englishName : null
  }

  get initialBrand(): ApiBrand | null {
    if (this.maybeInitialBrandEnglishName === null) {
      return null
    }

    return _.find(this.brandList, (b) => {
      return b.englishName === this.maybeInitialBrandEnglishName
    }) || null
  }

  get allBrands(): ApiBrand[] {
    return this.brandList
  }

  private get maybeInitialBrandEnglishName(): string | null {
    return extractBrandFromUrl(document.referrer)
  }

  transferableBrands(brand: ApiBrand): ApiBrand[] {
    // SMb から他ブランドは見えないようにする
    // https://www.chatwork.com/#!rid87550748-1249710666856570880
    // https://github.com/my-color/front/issues/3641#issuecomment-616259982
    if (brand.isSMBrand) {
      return this.brandsByCompanyId(brand.companyId)
    }

    return this.allBrands
  }

  async initBrandList(): Promise<void> {
    const brandService = new BrandService()
    const brandResult = await brandService.list()

    if (brandResult.isLeft()) {
      return
    }

    const rawBrandList = brandResult.value.body.data as any[]
    this.brandList = rawBrandList.map(b => new ApiBrand(b))
  }

  private brandsByCompanyId(companyId: string): ApiBrand[] {
    return _.filter(this.brandList, (b) => {
      return b.companyId === companyId
    })
  }
}
